var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.148 23.717 C 72.949 23.717 89 36.894 89 53.148 c 0 6.203 -2.341 11.954 -6.334 16.698 c -1.913 2.273 -1.679 5.651 0.547 7.618 L 89 82.579 H 53.148 c -19.8 0 -35.852 -13.177 -35.852 -29.431 C 17.296 36.894 33.348 23.717 53.148 23.717 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,220,158)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89 83.579 H 53.148 c -20.32 0 -36.852 -13.651 -36.852 -30.431 c 0 -16.78 16.532 -30.431 36.852 -30.431 S 90 36.369 90 53.148 c 0 6.239 -2.271 12.235 -6.569 17.341 c -1.579 1.876 -1.384 4.61 0.444 6.227 l 5.787 5.114 c 0.312 0.275 0.42 0.714 0.273 1.104 C 89.788 83.322 89.416 83.579 89 83.579 z M 53.148 24.717 c -19.217 0 -34.852 12.754 -34.852 28.431 s 15.635 28.431 34.852 28.431 h 33.21 l -3.808 -3.365 c -2.648 -2.341 -2.934 -6.299 -0.649 -9.013 C 85.891 64.461 88 58.91 88 53.148 C 88 37.472 72.365 24.717 53.148 24.717 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.852 7.421 C 17.051 7.421 1 20.598 1 36.852 c 0 6.203 2.341 11.954 6.334 16.698 c 1.913 2.273 1.679 5.651 -0.547 7.618 L 1 66.283 h 35.852 c 19.8 0 35.852 -13.177 35.852 -29.431 C 72.704 20.598 56.652 7.421 36.852 7.421 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(49,193,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.852 67.282 H 1 c -0.416 0 -0.788 -0.257 -0.935 -0.646 c -0.147 -0.39 -0.039 -0.828 0.273 -1.104 l 5.787 -5.114 c 1.828 -1.615 2.023 -4.35 0.444 -6.226 C 2.271 49.088 0 43.091 0 36.852 C 0 20.073 16.532 6.421 36.852 6.421 c 20.32 0 36.852 13.651 36.852 30.431 C 73.704 53.631 57.172 67.282 36.852 67.282 z M 3.642 65.282 h 33.21 c 19.217 0 34.852 -12.754 34.852 -28.43 c 0 -15.677 -15.635 -28.431 -34.852 -28.431 S 2 21.175 2 36.852 c 0 5.762 2.109 11.313 6.1 16.054 c 2.283 2.713 1.998 6.671 -0.65 9.011 L 3.642 65.282 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.494999999999997,
    cy: 36.185,
    r: 5.045,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.495,
    cy: 36.185,
    r: 5.045,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.495000000000005,
    cy: 36.185,
    r: 5.045,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.495 42.234 c -3.333 0 -6.044 -2.712 -6.044 -6.045 s 2.711 -6.044 6.044 -6.044 s 6.045 2.711 6.045 6.044 S 19.828 42.234 16.495 42.234 z M 16.495 32.145 c -2.23 0 -4.044 1.814 -4.044 4.044 c 0 2.23 1.814 4.045 4.044 4.045 c 2.23 0 4.045 -1.814 4.045 -4.045 C 20.54 33.959 18.726 32.145 16.495 32.145 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.495 42.234 c -3.333 0 -6.044 -2.712 -6.044 -6.045 s 2.711 -6.044 6.044 -6.044 s 6.045 2.711 6.045 6.044 S 39.828 42.234 36.495 42.234 z M 36.495 32.145 c -2.23 0 -4.044 1.814 -4.044 4.044 c 0 2.23 1.814 4.045 4.044 4.045 c 2.23 0 4.045 -1.814 4.045 -4.045 C 40.54 33.959 38.726 32.145 36.495 32.145 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.495 42.234 c -3.333 0 -6.044 -2.712 -6.044 -6.045 s 2.711 -6.044 6.044 -6.044 s 6.045 2.711 6.045 6.044 S 59.828 42.234 56.495 42.234 z M 56.495 32.145 c -2.229 0 -4.044 1.814 -4.044 4.044 c 0 2.23 1.814 4.045 4.044 4.045 c 2.23 0 4.045 -1.814 4.045 -4.045 C 60.54 33.959 58.726 32.145 56.495 32.145 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/Chats.de660beb1932f40cd30fb110eae48368.svg";
export { ForwardRef as ReactComponent };